import React from 'react';

const AWS_Cloud_Exercises = () => {
  return (
    <div>
      <h1>AWS_Cloud_Exercises</h1>
      <p>This is the AWS_Cloud_Exercises component.</p>
    </div>
  );
};

export default AWS_Cloud_Exercises;
